import common from '@/utils/common'
import * as query from '@/queries/stock'

const defaultState = function () {
  return {
    mode: 0,
    returnList: false,
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'stockMove_list',
    searchConditions: {}
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    async update (state, condition) {
      const noQuery = common.addGraphQlCondition(query.GRAPH_QL_QUERY_STOCK_MOVE_LIST, condition)
      const res = await common.postGraphQl(noQuery)
      state.tdLists = common.getValueByPath(res.data, 'data.stockMoveList.edges')
      state.totalCount = common.getValueByPath(res.data, 'data.stockMoveList.totalCount')
    }
  },
  getDefaultState: defaultState
}
